import React from 'react';
import { t } from 'i18next';

// 1. DỊNH NGHĨA INTERFACE CHO DỮ LIỆU GIAO DỊCH
export interface TradeDetailsData {
    type?: string;
    openPrice?: string | number;
    closePrice?: string | number;
    currentBid?: string | number;
    currentAsk?: string | number;
    spread?: string | number;

    stopLoss?: string | number;
    slPips?: string | number;
    takeProfit?: string | number;
    tpPips?: string | number;

    grossProfit?: string | number;
    swap?: string | number;
    commission?: string | number;
    netProfit?: string | number;

    openTime?: string;
    closeTime?: string;

    maePip?: string | number;
    mae?: string | number;
    maeTime?: string;

    mfePip?: string | number;
    mfe?: string | number;
    mfeTime?: string;
}

interface TradeDetailsProps {
    data?: TradeDetailsData;
}

// 2. HELPER COMPONENTS ĐỂ TỐI ƯU CODE
const SectionHeader: React.FC<{ icon: React.ReactNode; title: string }> = ({ icon, title }) => (
    <div className="flex items-center gap-1 pb-[10px]">
        <span className="text-content-primary">{icon}</span>
        <span className="text-headings-headline text-content-primary font-medium">{title}</span>
    </div>
);

const DetailRow: React.FC<{ label: string; value: React.ReactNode; isColumn?: boolean }> = ({
    label,
    value,
    isColumn = false,
}) => (
    <div className={`flex pb-2 ${isColumn ? 'mb-1 flex-col' : ''}`}>
        <span className="flex-1 text-labels-small text-content-tertiary text-gray-500">{label}</span>
        <span className="flex-1 text-labels-small text-content-primary font-medium">{value ?? '-'}</span>
    </div>
);

// 3. COMPONENT CHÍNH
export const TradeDetailsCard: React.FC<TradeDetailsProps> = ({ data }) => {
    // Dữ liệu mặc định nếu không truyền prop
    const trade = {
        type: 'Mua',
        openPrice: '4,060.86',
        closePrice: '-',
        currentBid: '0.00',
        currentAsk: '0.00',
        spread: '0',
        stopLoss: '-',
        slPips: '-',
        takeProfit: '-',
        tpPips: '-',
        grossProfit: '$0.17',
        swap: '?',
        commission: '?',
        netProfit: '?',
        openTime: '09 Jul 2026 00:41:53',
        closeTime: '-',
        maePip: '?',
        mae: '?',
        maeTime: '?',
        mfePip: '?',
        mfe: '?',
        mfeTime: '?',
        ...data,
    };

    const isBuy = trade.type === 'Mua' || trade.type === 'Buy';

    return (
        <div className="_tradeSections_1jkqp_16">
            {/* --- SECTION 1: GIÁ ĐÓNG LỆNH --- */}
            <div>
                <SectionHeader
                    title={t('metrixLive.trade.prices')}
                    icon={
                        <svg width="14" height="18" viewBox="0 0 14 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.2991 7.9704H8.0574V4.89698H12.9426V2.84804H8.0574V0H5.9426V2.85828H3.70091C1.66012 2.85828 0 4.4667 0 6.44394C0 8.42117 1.66012 10.0296 3.70091 10.0296H5.9426V13.103H1.0574V15.152H5.9426V18H8.0574V15.152H10.2991C12.3399 15.152 14 13.5435 14 11.5663C14 9.58907 12.3399 7.9704 10.2991 7.9704ZM3.70091 7.9704C2.82326 7.9704 2.1148 7.28401 2.1148 6.43369C2.1148 5.58338 2.82326 4.89698 3.70091 4.89698H5.9426V7.9704H3.70091ZM10.2991 13.0928H8.0574V10.0194H10.2991C11.1767 10.0194 11.8852 10.7057 11.8852 11.5561C11.8852 12.4064 11.1767 13.0928 10.2991 13.0928Z" fill="currentColor" />
                        </svg>
                    }
                />
                <DetailRow
                    label={t('metrixLive.cols.order')}
                    value={
                        <span className={isBuy ? 'text-functional-success text-green-500' : 'text-functional-danger text-red-500'}>
                            {trade.type}
                        </span>
                    }
                />
                <DetailRow label={t('metrixLive.trade.open')} value={trade.openPrice} />
                <DetailRow label={t('metrixLive.trade.close')} value={trade.closePrice} />

                {/* Sub-section: Hiện tại */}
                {/* <div className="_currentSubSection_1jkqp_42 pt-2">
                    <div className="mb-2 text-sm font-semibold">
                        <span>{t('metrixLive.trade.current')}</span>
                    </div>
                    <DetailRow label={t('metrixLive.trade.bid')} value={trade.currentBid} />
                    <DetailRow label={t('metrixLive.trade.ask')} value={trade.currentAsk} />
                    <DetailRow label="Spread" value={trade.spread} />
                </div> */}
            </div>

            {/* --- SECTION 2: QUẢN LÝ GIAO DỊCH --- */}
            <div>
                <SectionHeader
                    title={t('metrixLive.trade.management')}
                    icon={
                        <svg width="16" height="18" viewBox="0 0 16 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.157 0H2.84297C1.27509 0 0 1.24233 0 2.76994V13.3067C0 13.6472 0.188902 13.9509 0.491146 14.1166L7.54663 17.8896C7.68831 17.9632 7.84888 18 8 18C8.16056 18 8.31169 17.9632 8.45336 17.8896L15.5089 14.1166C15.8111 13.9509 16 13.6472 16 13.3067V2.76994C16 1.24233 14.7249 0 13.157 0ZM14.111 12.773L8 16.0399L1.88902 12.773V2.76994C1.88902 2.2546 2.31405 1.84049 2.84297 1.84049H13.157C13.686 1.84049 14.111 2.2546 14.111 2.76994V12.773Z" fill="currentColor" />
                        </svg>
                    }
                />
                <DetailRow label={t('metrixLive.trade.stopLoss')} value={trade.stopLoss} />
                {/* <DetailRow label="SL (Pips)" value={trade.slPips} /> */}
                <DetailRow label={t('metrixLive.trade.takeProfit')} value={trade.takeProfit} />
                {/* <DetailRow label="TP (Pips)" value={trade.tpPips} /> */}
            </div>

            {/* --- SECTION 3: KẾT QUẢ --- */}
            <div>
                <SectionHeader
                    title={t('metrixLive.result.label')}
                    icon={
                        <svg width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                            <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"></path>
                        </svg>
                    }
                />
                <DetailRow label={t('metrixLive.trade.grossProfit')} value={trade.grossProfit} isColumn />
                {/* <DetailRow label="Phí qua đêm" value={trade.swap} isColumn />
                <DetailRow label="Phí hoa hồng" value={trade.commission} isColumn />
                <DetailRow label="Lợi nhuận ròng" value={trade.netProfit} isColumn /> */}
            </div>

            {/* --- SECTION 4: THỜI GIAN --- */}
            <div>
                <SectionHeader
                    title={t('metrixLive.trade.time')}
                    icon={
                        <svg width="16" height="18" viewBox="0 0 16 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.2839 4.96012L14.074 3.95706L12.4839 2.86196L11.6444 3.92025C10.8345 3.53374 9.93576 3.26687 8.98762 3.15644V1.84049H11.4567V0H4.54319V1.84049H7.01232V3.15644C3.06172 3.61656 0 6.7454 0 10.546C0 14.6595 3.58517 18 7.99997 18C12.4148 18 15.9999 14.6595 15.9999 10.546C16.0098 8.31902 14.953 6.32209 13.2839 4.96012ZM8.00984 16.1595C4.69134 16.1595 1.98518 13.638 1.98518 10.546C1.98518 7.45399 4.69134 4.93252 8.00984 4.93252C11.3283 4.93252 14.0345 7.45399 14.0345 10.546C14.0345 13.6472 11.3283 16.1595 8.00984 16.1595Z" fill="currentColor" />
                            <path d="M8.75003 9.85586V6.30371H7.26855V10.5552C7.26855 10.9325 7.60436 11.2454 8.00929 11.2454H12.5722V9.86506H8.75003V9.85586Z" fill="currentColor" />
                        </svg>
                    }
                />
                <DetailRow label={t('metrixLive.trade.open')} value={trade.openTime} isColumn />
                {/* <DetailRow label="Đã đóng" value={trade.closeTime} isColumn /> */}
            </div>

            {/* --- SECTION 5: THỐNG KÊ GIAO DỊCH --- */}
            {/* <div>
                <SectionHeader
                    title={t('metrixLive.trade.stats')}
                    icon={
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clipPath="url(#clip0_6_2798)">
                                <path d="M2.59566 21.4054V0H0V24H24V21.4054H2.59566Z" fill="currentColor" />
                                <path d="M4.94773 11.8576H6.86175C7.22307 11.8576 7.56485 11.6526 7.73087 11.3305L10.4945 6.01051C10.5628 5.88361 10.7484 5.89337 10.7679 5.89337C10.7972 5.89337 10.9534 5.91289 10.9925 6.01051L14.8596 15.8988C15.1721 16.709 15.9631 17.2361 16.881 17.2556C16.9006 17.2556 16.9103 17.2556 16.9299 17.2556C17.8283 17.2556 18.6193 16.7578 18.9611 15.9769L21.2852 10.7057H23.0235C23.5606 10.7057 24 10.2665 24 9.72959C24 9.19272 23.5606 8.75345 23.0235 8.75345H20.6505C20.2599 8.75345 19.9083 8.97796 19.7521 9.33914L17.174 15.1862C17.1252 15.3033 16.9592 15.3131 16.9201 15.3131C16.8615 15.3131 16.7248 15.3033 16.676 15.196L12.8089 5.29792C12.4964 4.50725 11.7542 3.9899 10.8656 3.94109C9.96714 3.89229 9.16638 4.34131 8.766 5.1027L6.27582 9.9053H4.94773C4.41063 9.9053 3.97119 10.3446 3.97119 10.8814C3.97119 11.4183 4.41063 11.8576 4.94773 11.8576Z" fill="currentColor" />
                            </g>
                            <defs>
                                <clipPath id="clip0_6_2798">
                                    <rect width="24" height="24" fill="currentColor" />
                                </clipPath>
                            </defs>
                        </svg>
                    }
                />
                <div>
                    <DetailRow label="MAE pip" value={trade.maePip} />
                    <DetailRow label="MAE" value={trade.mae} />
                    <DetailRow label={t('metrixLive.trade.maeTime')} value={trade.maeTime} />
                </div>
                <div className="pt-[10px]">
                    <DetailRow label="MFE pip" value={trade.mfePip} />
                    <DetailRow label="MFE" value={trade.mfe} />
                    <DetailRow label={t('metrixLive.trade.mfeTime')} value={trade.mfeTime} />
                </div>
            </div> */}

        </div>
    );
};